import { Box, Skeleton } from "@mantine/core";
import CustomerMenu from "../../../Tags-old/CustomerMenu";
import { useEffect, useState } from "react";
import { getNestedFieldValue } from "../../../ideaNiv/helpers/calculateImpactResults";

export const CustomersCell: React.FC<any> = ({ data, col }) => {

  const [customers, setCustomers] = useState<string[]>([]);

  useEffect(() => { 
    const value = getNestedFieldValue(data, col.accessor) || [];
    setCustomers(value || []);
  }, [col.accessor])

  return (
    <Box p={0} m={0} h="100%" w="100%" onMouseMove={(e) => e.stopPropagation()}>
      <CustomerMenu
        customers={customers}
        colTitle={col?.title || "Customer"}
      />
    </Box>
  );
};

// Skeleton component for CustomersCell
export const CustomersCellSkeleton: React.FC<{ col: any }> = ({ col }) => {
  const columnWidth = col.width;
  const minWidth = col.minWidth;
  const maxWidth = col.maxWidth;
  
  // Customer cells typically show a customer menu/count
  const width = columnWidth ? Math.min(parseInt(columnWidth) * 0.7, 100) : 80;
  
  return (
    <Box 
      p={0} 
      m={0} 
      h="100%" 
      w="100%"
      sx={{ 
        width: columnWidth || "100%", 
        minWidth, 
        maxWidth,
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Skeleton height={28} width={width} radius="md" />
    </Box>
  );
};
